module.exports = __webpack_public_path__ + "img/oterra-logo.5ecf6fdf.jpg";